import {
  ssnSchema,
  ssnUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { DEFAULT_TITLE_OPTS, titleWithNameUI } from '../../definitions';
import content from '../../locales/en/content.json';
import { validateApplicantSsn } from '../../utils/validation';

const TITLE_TEXT = content['applicants--identification-info-title'];

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.applicant),
    applicantSsn: {
      ...ssnUI(),
      'ui:options': { useAllFormData: true },
      'ui:validations': [validateApplicantSsn],
    },
  },
  schema: {
    type: 'object',
    required: ['applicantSsn'],
    properties: {
      applicantSsn: ssnSchema,
    },
  },
};
